import { render } from "./MyProfileTab.vue?vue&type=template&id=19b18aac"
import script from "./MyProfileTab.vue?vue&type=script&lang=js"
export * from "./MyProfileTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__